import { createApi } from "@reduxjs/toolkit/query/react"
import { authQuery } from "./authQuery"
import { UserPermissions } from "@custom-types/user"
import { PermissionBody } from "@custom-types/permission"

export const accessApi = createApi({
  reducerPath: "accessApi",
  baseQuery: authQuery,
  tagTypes: ["Access"],
  endpoints: (builder) => ({
    getPermissions: builder.query<UserPermissions, void>({
      query: () => ({
        url: "/user/permissions/me",
      }),
      providesTags: ["Access"],
    }),
    addPermission: builder.mutation<string, PermissionBody>({
      query: (body) => ({
        url: `/user/permission`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Access"],
    }),
    deletePermission: builder.mutation<string, PermissionBody>({
      query: (body) => ({
        url: `/user/permission`,
        method: "DELETE",
        body,
      }),
      invalidatesTags: ["Access"],
    }),
  }),
})

export const { useAddPermissionMutation, useDeletePermissionMutation, useLazyGetPermissionsQuery } =
  accessApi
